import SearchableSelect from './SearchableSelect';
import { PM_NONE, pmOptionsFrom } from '../utils/programFilters';

/**
 * ProgramFilters — the program status + main PM dropdowns, shared by the
 * Programs page header and Week at a Glance so the two can't drift.
 * Pair with `filterPrograms()` from `src/utils/programFilters.js`.
 *
 * Props:
 *   statuses       — program_status lookup values ([{value}]), for the status list
 *   programs       — the unfiltered programs, for the PM list
 *   status, onStatusChange — '' means all statuses
 *   pm, onPmChange — '' means all PMs; a PM's id (string) or PM_NONE
 */
export default function ProgramFilters({ statuses, programs, status, onStatusChange, pm, onPmChange }) {
  return (
    <>
      <SearchableSelect value={status} onChange={onStatusChange}
        placeholder="All program statuses"
        options={statuses.map(s => ({ value: s.value, label: s.value }))} />
      <SearchableSelect value={pm} onChange={onPmChange}
        placeholder="All PMs"
        options={[...pmOptionsFrom(programs), { value: PM_NONE, label: 'No PM assigned' }]} />
    </>
  );
}
